export default function (data) {
  if (!data) {
    return null
  }

  return {
    email: data.email,
    phone: data.phone,
    emailApproved: data.email_approved,
    phoneApproved: data.phone_approved,
    username: data.username,
    vip: data.vip,
    gotWb: data.got_wb,
    currency: {
      name: data.currency_name,
      code: data.currency_code,
    },
    thresholdStatus: data.threshold_status,
    threshold: {
      amount: data.threshold_sum,
      current: data.current_threshold_sum,
    },
    activeVager: data.active_vager,
    inviteCode: data.invite_code,
    esbfou: data.esbfou,
    receiveSms: data.receive_sms,
    bonusIterator: data.bonus_iterator,
    minPay: data.min_pay,
    minPaySum: data.get_min_paysumm,
    specialUser: data.special_user,
    dobpay: data.dobpay,
    mmc: data.mmc,
    mmcPercent: data.info_mmc_percent,
    rub2kzt: data.rub2kzt,
    language: data.language,
    withdrawAccess: data.withdraw_access,
    withdrawAccessStr: data.withdraw_access_str,
    payTrxsExists: data.get_pay_trxs_count,
    profileIsApproved: data.profile_is_approved,
    profileIsApprovedSum: data.profile_is_approved_sum,
    bkProfileIsApproved: data.bk_profile_is_approved,
    personalDataIsFilled: data.personal_data_is_filled,
    securityQuestionId: data.security_question_id,
    securityQuestionAnswer: data.security_question_answer,
    documentNum: data.document_num,
    name: data.name,
    middleName: data.middle_name,
    surname: data.surname,
  }
}
